import { createContext } from 'react';

export const TestStatecontext = createContext('');
